import React, { useState } from "react";
import { useMsal } from "@azure/msal-react";
import IncidentModal from "./IncidentModal";
import NavigationMenu from "./NavigationMenu";
import { useUserPermissions } from "./useUserPermissions";

function Header({ route, navigation, loggedIn = false }) {
  const { accounts } = useMsal();
  const [isIncidentModalOpen, setIsIncidentModalOpen] = useState(false);
  const { permissions, userInfo } = useUserPermissions(loggedIn, accounts);

  const openIncidentModal = () => {
    setIsIncidentModalOpen(true);
  };

  const closeIncidentModal = () => {
    setIsIncidentModalOpen(false);
  };

  return (
    <header>
      <div className="header-container">
        <div className="logo">
          <a href="/" aria-label="Home">
            <picture>
              <source srcSet="/assets/img/logo.webp" type="image/webp" />
              <source srcSet="/assets/img/logo.png" type="image/png" />
              <img alt="logo" src="/assets/img/logo.png" />
            </picture>
          </a>
        </div>
        <div>
          <h3 className="header h3 luna-title">
            Gifting Account &amp; Transaction Environment
          </h3>
        </div>
        { loggedIn && (
        <div className="incident-button">
          <button
            className="ln-c-button ln-c-button--filled"
            onClick={openIncidentModal}
          >
            Log Issue
          </button>
        </div>) }
      </div>

      <IncidentModal
        modal={isIncidentModalOpen && loggedIn}
        onClose={closeIncidentModal}
        userEmail={userInfo.email}
        userName={userInfo.name}
      />

      <NavigationMenu
        loggedIn={loggedIn}
        permissions={permissions}
        accounts={accounts}
      />
    </header>
  );
}

export default Header;
